












































import { WarehouseItemCustomization } from "@/models";
import { customizationStore } from "@/store/typed";
import { Vue, Component, Ref } from "vue-property-decorator";
import VIconButton from "@/components/Common/VIconButton.vue";
import ThreeGenericCanvas from "@/components/Common/ThreeGenericCanvas.vue";
import DotLoader from "@/components/Common/DotLoader.vue";

@Component({
  components: {
    VIconButton,
    ThreeGenericCanvas,
    DotLoader,
  },
})
export default class CustomizationItemsCarousel extends Vue {
  private currentSelectedItemUuid = "";
  private showCanvas = true;
  private loadingPreview = true;

  @Ref() readonly canvasContainer!: any;

  onPreviewLoaded() {
    setTimeout(() => {
      
      this.loadingPreview = false;
    }, 500);
   
  }

  get items(): WarehouseItemCustomization[] {
    return customizationStore.warehouseItemCustomizations;
  }

  get currentItem(): WarehouseItemCustomization {
    return this.items.find(
      (item) => item.uuid === this.currentSelectedItemUuid
    );
  }

  get totalObjects() {
    return (
      customizationStore.productCustomization?.warehouseItemCustomizations
        ?.length || 0
    );
  }

  get objectConfig() {
    const wia = this.currentItem?.warehouseItem?.warehouseItemArtifact;
    return {
      zoom: wia.zoom || 5,
      rotationX: wia.rotationX || 0,
      rotationY: wia.rotationY || 0,
      rotationZ: wia.rotationZ || 0,
    };
  }

  mounted() {
    if (this.items) {
      this.currentSelectedItemUuid = this.items[0].uuid;
    }
  }

  get canvasHeight() {
    return (this.$refs.canvasContainer as any)?.clientHeight || 400;
  }

  get currentSelectedItemName(): string {
    return this.currentItem?.warehouseItem?.name || "";
  }

  get currentSelectedItemIndex(): number {
    return (
      this.items.findIndex(
        (item: WarehouseItemCustomization) =>
          item.uuid === this.currentSelectedItemUuid
      ) || 0
    );
  }

  get currentAssetUrl(): string | null {
    const warehouseItem = this.currentItem?.warehouseItem;
    return warehouseItem?.warehouseItemArtifact?.artifact?.asset?.url || null;
  }

  private onPrev() {
    this.currentSelectedItemUuid =
      this.currentSelectedItemIndex === 0
        ? this.items[this.items.length - 1].uuid
        : this.items[this.currentSelectedItemIndex - 1].uuid;
    this.showCanvas = false;

    this.$nextTick(() => (this.showCanvas = true));
  }

  private onNext() {
    this.currentSelectedItemUuid =
      this.currentSelectedItemIndex === this.items.length - 1
        ? this.items[0].uuid
        : this.items[this.currentSelectedItemIndex + 1].uuid;
    this.showCanvas = false;
    this.$nextTick(() => (this.showCanvas = true));
  }
}
